/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Box, Paper, Typography, CircularProgress } from '@material-ui/core'
import { useStyle } from './styles'

const Loading = (visible) => {
	const [loading, setLoading] = useState(visible)
	useEffect(() => {
		setLoading(visible)
	}, [visible])
	const classes = useStyle({ loading })

	return (
		<Box className={classes.container}>
			<Paper>
				<Box className={classes.loadingBox}>
					<CircularProgress />
					<Box mt={2}>
						<Typography variant='body1'>
							This will only take a moment, <br />
							Please wait...
						</Typography>
					</Box>
				</Box>
			</Paper>
		</Box>
	)
}

export default Loading
